// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"96015ccb","239":"82c3ba0e","453":"6b418f2b","732":"7c5fcf10","977":"e2991a8c"}[chunkId] + ".chunk.js";
};